import React, { useCallback } from 'react';
import type { Nullable } from 'corgi-types';
import { HomeClubSectionFlow } from 'corgi-types';

import DrawerContent from 'common/components/HomeClubDrawer';
import type { Slices } from 'common/components/HomeClubDrawer/types';
import { useOpenDrawer } from 'common/hooks/drawer';
import { useLocalization } from 'common/providers/LocaleProvider';
import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { DrawerInteraction, Element as ElementType } from 'common/types/tracking';

interface HomeClubDrawerArgs {
  homeClubSlices: Nullable<Slices>;
}

const DRAWER_WIDTH = ['100%', '80%'];

export const useHomeClubDrawer = ({ homeClubSlices }: HomeClubDrawerArgs) => {
  const { t } = useLocalization();

  const openHomeClubDrawer = useOpenDrawer({
    title: t('h24_hc_submit_btn_label'),
    content: homeClubSlices ? (
      <DrawerContent slices={homeClubSlices} flow={HomeClubSectionFlow.Signup} />
    ) : null,
    width: DRAWER_WIDTH,
  });

  const onHomeClubLinkClick = useCallback(() => {
    dispatchTrackingEventGA4({
      event: 'registration-form-hc-consent_click',
      element: ElementType.Link,
      interaction: DrawerInteraction.Open,
    });
    openHomeClubDrawer();
  }, []);

  return onHomeClubLinkClick;
};
